import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from './Button';

class FileControl extends Component {
	constructor(props) {
		super(props);

		this.selectFile = this.selectFile.bind(this);
		this.updateFilename = this.updateFilename.bind(this);
	}
	selectFile() {
		this.fileInput.click();
	}
	updateFilename() {
		const files = this.fileInput.files;

		if (files.length > 0) {
			this.props.dispatchChange(this.props.setFilename, this.props.fileId, files[0].name);
			this.props.dispatchChange(this.props.storeBlob, this.props.fileId, files[0]);
		}
	}
	render() {
		return (
			<div>
				<div>
					<Button
						id="select-file-button"
						onClick={this.selectFile}
					>
						Select File
					</Button>
					<input
						type="file"
						accept=".csv"
						ref={(input) => { this.fileInput = input; }} 
						onChange={this.updateFilename} 
					/>
					<span className="filepath">{this.props.filename}</span>
				</div>
				<Button id="read-file-button"
					onClick={() => this.props.dispatchChange(this.props.loadFile, this.props.fileId)}
					enabled={!this.props.isLoaded}
					>Open File</Button>
			</div>
		);
	}
};

FileControl.propTypes = {
	fileId: PropTypes.string,
	filename: PropTypes.string.isRequired,
	isLoaded: PropTypes.bool.isRequired,
	setFilename: PropTypes.func.isRequired,
	storeBlob: PropTypes.func.isRequired,
	loadFile: PropTypes.func.isRequired,
	dispatchChange: PropTypes.func,
};

const mapDispatchToProps = dispatch => {
	return {
		dispatchChange: (handler, fileId, value) => {
			handler(fileId, value, dispatch);
		}
	}
};

export default connect(null, mapDispatchToProps)(FileControl);


// WEBPACK FOOTER //
// ./src/components/FileControl.js